import React from 'react';

export const NewBadge = () => {
  return (
    <span className="inline-flex items-center justify-center w-5 h-5 ml-auto text-xs font-semibold text-white bg-[#1B4332] rounded-full">
      1
    </span>
  );
};
